import React from 'react';
import GoogleSyncSettingsPage from '../settings/GoogleSyncSettingsPage';
import type { EmbeddedInConfigurationHub } from './models';

const GoogleSyncSettingsModule: React.FC<EmbeddedInConfigurationHub> = ({ embedded = true }) => (
  <GoogleSyncSettingsPage embedded={embedded} />
);

export default GoogleSyncSettingsModule;
